module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Trail-03-922411f99f9c21b632ef22c3ba8a32f3.png";